import { IMAGESMAP } from "../utils/imagesMap"

/*
 *  UGC RESULT DATA
 */

export const crystal = {
  icon: IMAGESMAP.RESULTS_UGC.CRYSTAL_TN,
  beforeImage: IMAGESMAP.RESULTS_UGC.CRYSTAL_BEFORE,
  afterImage: IMAGESMAP.RESULTS_UGC.CRYSTAL_AFTER,
  imageDirection: "right",
  quote:
    "My hair was so thin and was shedding in the shower everyday. I never kept it down because I was so insecure of how thin my hair was. And it stopped growing. Now that I started Nutrafol Women, I no longer have tons of shedding. I have improved hair growth!.",
  name: "Crystal",
  tags: [],
  productSku: "WOM",
  product: "Nutrafol Women Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "4",
  action: "Taking",
  pdp: "/nutrafol-core-for-women/",
}

export const joanna = {
  icon: IMAGESMAP.RESULTS_UGC.JOANNA_TN,
  beforeImage: IMAGESMAP.RESULTS_UGC.JOANNA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_UGC.JOANNA_AFTER,
  imageDirection: "right",
  quote:
    "I'm 35 years old, and had my last child 5 years ago. Since then I noticed the part on my head had thinned a lot. I went to a cosmetic dermatologist and she told me I should try Nutrafol Women first. I've been taking photos monthly and have noticed a considerable difference in my hair quality.",
  name: "Joanna",
  tags: [],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  productSku: "WOM",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "5",
  action: "Taking",
  pdp: "/nutrafol-core-for-women/",
}

export const jamie = {
  icon: IMAGESMAP.RESULTS_UGC.JAMIE_TN,
  beforeImage: IMAGESMAP.RESULTS_UGC.JAMIE_BEFORE,
  afterImage: IMAGESMAP.RESULTS_UGC.JAMIE_AFTER,
  imageDirection: "right",
  quote: `Over the last year I have noticed my hair has become so thin and dead. I used to have such thick hair and it broke my heart with how thin it became. Since starting Nutrafol Women my hair has become so much visibly fuller and I notice way less shedding than I used to have in the shower. I am finally starting to see a more fuller look and others have also told me how much better my hair looks.`,
  name: "Jamie",
  tags: [],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  productSku: "WOM",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "4",
  action: "Taking",
  pdp: "/nutrafol-core-for-women/",
}

export const katie = {
  icon: IMAGESMAP.RESULTS_UGC.KATIE_TN,
  beforeImage: IMAGESMAP.RESULTS_UGC.KATIE_BEFORE,
  afterImage: IMAGESMAP.RESULTS_UGC.KATIE_AFTER,
  imageDirection: "right",
  quote: `I’d always had very thick hair so seeing my hair thinning was pretty scary. I spoke with several doctors and my hair stylist and all recommended Nutrafol. The best part of my journey was when I went to my hair stylist for the first time after starting Nutrafol Women and within the first 5 minutes she immediately said “oh my gosh! Your hair is finally healthy!!`,
  name: "Katie",
  tags: [],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  productSku: "WOM",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "3",
  action: "Taking",
  pdp: "/nutrafol-core-for-women/",
}
